// https://vuex.vuejs.org/en/mutations.html
import * as TYPES from './mutations-types'

/* eslint-disable no-param-reassign */
export default {
  [TYPES.SET_TOKEN] (state, value) {
    state.token = value
  },
  [TYPES.SET_USER] (state, value) {
    state.user = value
  },
  [TYPES.SET_BASE_URL] (state, value) {
    state.type = value
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/vuex/mutations.js